import React from 'react';
import { Col, Spinner } from 'react-bootstrap';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
interface VerificationFieldProps {
    confirmationToken?: string;
    changeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
    resendVerify: () => void;
    isLoading: boolean;
}
const VerificationField = ({ confirmationToken, changeHandler, resendVerify, isLoading }: VerificationFieldProps) => {
    const { t } = useTranslation();
    return (
        <>
            <Col md={7}>
                <TextField
                    label="Code"
                    value={confirmationToken}
                    onChange={changeHandler}
                    name="confirmationToken"
                    variant="outlined"
                    size="small"
                    required
                    className="w-100 my-2"
                />
                <div className="d-flex align-items-center justify-content-between">
                    <span className="text-muted">{t('auth.register.brand.step2.checkSpamFolder')}</span>
                    <a
                        className="d-flex align-items-center justify-content-center cursor-pointer"
                        onClick={() => resendVerify()}
                    >
                        {isLoading ? (
                            <>
                                Loading... <Spinner animation="border" size="sm" role="status" className="ml-1" />
                            </>
                        ) : (
                            t('auth.register.brand.step2.reSend')
                        )}
                    </a>
                </div>
            </Col>
        </>
    );
};

export default VerificationField;
